import { connect } from "react-redux";
import { PageShowcase, PageShowcaseWeb } from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  PageShowcaseProps,
  PageShowcasePropsDispach,
  PageShowcaseState,
} from "senac-components/dist/pages/Mobile/PageShowcase";
import {
  Content,
  ContentGroup,
  MenuOptions,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  loadAndOpenContent,
  showContentDetail,
} from "../store/reducers/contentSlice";
import { PageShowcaseWebProps } from "senac-components/dist/pages/Web/PageShowcase";
import { filterContent } from "../store/reducers/common";
import { useEffect, useRef, useState } from "react";
import {
  getReviewContents,
  historyContents,
  reloadUserData,
} from "../store/reducers/userDataSlice";
import { useNavigate } from "react-router";
import { RemoteContentDetail } from "../services/contents/IContentService";


const mapState = (state: RootState) => {
  const authenticatedUser = state.userState.user != undefined;
  const allContents = state.contentState.allContents;



  let keepReding: ContentGroup[] = [];
  let contents: ContentGroup[] = [];

  const orderedBooks = (contentOrderedIds?: string[]) => {
    const books: RemoteContentDetail[] = []; // melhora fluxo para não filtrar array e ordernar corretamente.

    contentOrderedIds?.forEach(contentId => {
      const book = allContents.find(content => content.uid === contentId)
      if (book) books.push(book)
    })

    return books;
  };

  const progressRead = (book: any) => {
    let progress = 1;
    try {
      const interactions: any[] = book.interactions;

      if (interactions) {
        interactions.forEach((item) => {
          if (item.interaction_progress > progress)
            progress = item.interaction_progress;
        });
      }
    } catch (err) {
      console.log(err);
    }

    return progress
  };

  if (authenticatedUser) {
    if (state.userDataState.worksToReview) {
      contents.push({
        title: "Obras para revisitar",
        uid: "keep",
        books: orderedBooks(state.userDataState.worksToReview)
      });
    }
    if (state.userDataState.historyReading) {
      keepReding.push({
        title: "Continue lendo",
        uid: "keep",
        books: orderedBooks(state.userDataState.historyReading)
        .map(book => ({
          ...book,
          progress: progressRead(book),
        }))
      });
    }

    if (state.contentState.suggestedContent) {
      contents.push({
        uid: "suggest",
        title: "Você pode gostar",
        books: orderedBooks(state.contentState.suggestedContent),
      });
    }
  } else {
    if (state.contentState.mostWantedContent) {
      contents.push({
        uid: "mostwa",
        title: "Os mais buscados",
        books: orderedBooks(state.contentState.mostWantedContent),
      });
    }
  }

  let result: PageShowcaseState = {
    contents: contents, //todo: tratar undefined para exibição do esqueleto
    contentsKeepReading: keepReding,
    categories: state.contentState.categories,
    authenticatedUser: authenticatedUser,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => 
{
  const result: PageShowcasePropsDispach & {
    refetchHistory?: VoidFunction;
    refetchReviewContents?: VoidFunction;
  } = {


    onSelectedContent: (content) => {
      if (!content.uid) return;
      dispatch(showContentDetail(content.uid));
    },
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
    onSelectedCategory: (category) => {
      if (!category) return;
      dispatch(filterContent({ category: category }));
    },
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    onClickLogin: () => dispatch(commonSlice.actions.loginOptionsPage()),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    onSelectedEditionEpub: (content: Content) =>
      dispatch(loadAndOpenContent(content.uid)),
    refetchHistory: () => {
      dispatch(historyContents());
    },
    refetchReviewContents: () => {
      dispatch(getReviewContents());
    },
  };
  return result;
};

const webMapDispatch = (dispatch: AppDispatch) => {
  const result: PageShowcaseWebProps & {
    onClickLogin: () => void;
    refetchHistory?: VoidFunction;
    refetchReviewContents?: VoidFunction;
  } = {
    onSelectedEditionEpub: (content: Content) =>
      dispatch(loadAndOpenContent(content.uid)),
    onSelectedContent: (content) => {
      if (!content.uid) return;
      dispatch(showContentDetail(content.uid));
    },
    onClickOptionFooter(option) {
      return dispatch(commonSlice.actions.goToMyProfileOption(option));
    },
    onSelectedHeaderBack() {},
    onClickLogin: () => dispatch(commonSlice.actions.loginOptionsPage()),
    onSelectedCategory: (category) => {
      if (!category) return;
      dispatch(filterContent({ category: category }));
    },
    onSelectedHeaderMenuOption(option) {},
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    refetchHistory: () => {
      dispatch(historyContents());
    },
    refetchReviewContents: () => {
      dispatch(getReviewContents());
    },
  };
  return result;
};

const ShowCaseWeb = ({
  refetchHistory,
  refetchReviewContents,
  authenticatedUser,
  ...props
}: PageShowcaseWebProps & {
  refetchHistory?: VoidFunction;
  refetchReviewContents?: VoidFunction;
}) => {
  const ref = useRef(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticatedUser) navigate("/user/options");

    if (ref.current === 0 && refetchHistory) {
      ref.current = ref.current + 1;
      refetchHistory();
      if(refetchReviewContents) refetchReviewContents();
    }
  }, []);

  return <PageShowcaseWeb authenticatedUser={authenticatedUser} {...props} />;
};

const ShowCaseMobile = ({
  refetchHistory,
  refetchReviewContents,
  authenticatedUser,
  ...props
}: PageShowcaseProps & {
  refetchHistory?: VoidFunction;
  refetchReviewContents?: VoidFunction;
}) => {
  const ref = useRef(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticatedUser) navigate("/user/options");

    if (ref.current === 0 && refetchHistory) {
      ref.current = ref.current + 1;
      refetchHistory();
      if(refetchReviewContents) refetchReviewContents();
    }
  }, []);

  return <PageShowcase authenticatedUser={authenticatedUser} {...props} />;
};

const Web = connect(mapState, webMapDispatch)(ShowCaseWeb);
const Mobile = connect(mapState, mapDispatch)(ShowCaseMobile);

const WPageShowcase = () => {
  const [initialized, setInitialized] = useState(true);


  const isMobile = window.innerWidth < 1024;

  if (isMobile) return <Mobile />;
  return <Web />;
};

export { WPageShowcase };
